import { render, staticRenderFns } from "./customColumn.vue?vue&type=template&id=44763340&scoped=true&"
import script from "./customColumn.vue?vue&type=script&lang=js&"
export * from "./customColumn.vue?vue&type=script&lang=js&"
import style0 from "./customColumn.vue?vue&type=style&index=0&id=44763340&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.10.0_enyi6aqizbgycdmugvkasw26ru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44763340",
  null
  
)

export default component.exports